module.exports = __webpack_public_path__ + "static/eu-logo-8e789a66f5dcb1e8a8038388b47dae3e.jpg";